import { useCallback, useEffect, useState } from 'react';
import { PREDEFINED_COUNTRY_CODES } from '../../constants';
import { CountryCode } from '../../types';

type Mask = string | null;

const usePhoneMask = (): [Mask, (newIsoCode: CountryCode | null) => void] => {
  const [mask, setMask] = useState<Mask>(null);
  const [countryCode, setCountryCode] = useState<CountryCode | null>(null);

  const onSetCountryCode = useCallback((newIsoCode: CountryCode | null) => {
    if (newIsoCode && PREDEFINED_COUNTRY_CODES[newIsoCode]) {
      setCountryCode(newIsoCode);
    } else {
      setCountryCode(null);
      setMask(null);
    }
  }, []);

  useEffect(() => {
    if (countryCode && PREDEFINED_COUNTRY_CODES[countryCode]) {
      setMask(PREDEFINED_COUNTRY_CODES[countryCode]);
    } else {
      setMask(null);
    }
  }, [countryCode]);

  return [mask, onSetCountryCode];
};

export default usePhoneMask;
